import request from '@/utils/request'

const basePath = '/api/instanceEnvDetails'


/**
 * 获取列表
 * @param params
 * @returns {*}
 */
export function getList(params) {
    return request({
        url: `${basePath}`,
        method: 'GET',
        params: params
    })
}


/**
 * 新建并获取运行实例环境详情
 * @param params
 * @returns {*}
 */
export function postInstanceEnvDetails(data) {
    return request({
        url: `${basePath}`,
        method: 'POST',
        data: data
    })
}

/**
 * 批量停止
 * @param params
 * @returns {*}
 */
export function stopInstanceEnvDetails(params) {
    return request({
        url: `${basePath}/stop`,
        method: 'PUT',
        params: params
    })
}


/**
 * 批量删除
 * @param params
 * @returns {*}
 */
export function deleteInstanceEnvDetails(params) {
    return request({
        url: `${basePath}`,
        method: 'DELETE',
        params: params
    })
}
